import { render } from "./MenuSessionList.vue?vue&type=template&id=6f0f4979&scoped=true"
import script from "./MenuSessionList.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MenuSessionList.vue?vue&type=script&charset=utf-8&lang=js"

import "./MenuSessionList.vue?vue&type=style&index=0&id=6f0f4979&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0f4979"]])

export default __exports__